import { render, staticRenderFns } from "./datatable-history.vue?vue&type=template&id=0cc47b42&scoped=true"
import script from "./datatable-history.vue?vue&type=script&lang=js"
export * from "./datatable-history.vue?vue&type=script&lang=js"
import style0 from "./datatable-history.vue?vue&type=style&index=0&id=0cc47b42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc47b42",
  null
  
)

export default component.exports